window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};

const detectCheckoutEle = (checkoutElements) => {
    let checkoutCustom = document.querySelectorAll('.bss-checkout');
    if (checkoutCustom.length === 0) {
      checkoutCustom = document.createElement('button');
      checkoutCustom.className = 'btn bss-checkout';
      checkoutCustom.textContent = 'Checkout';
  
      const target = document.querySelector('.button.button--large');
      target.style.display = 'none';
      if (target && target.parentNode) {
        target.parentNode.insertBefore(checkoutCustom, target);
      }
    }
    const portalBtn = document.querySelector('.bss-b2b-customer-portal-nt-checkout-btn');
      return [
    ...document.querySelectorAll('.bss-checkout'),
    ...(portalBtn ? [portalBtn] : [])
  ];
}
window.BSS_B2B.addFilter('custom:cart/checkout_ele', detectCheckoutEle);

document.addEventListener("theme:open-cart-drawer", () => {
  const interval = setInterval(() => {
    const ntButtons = document.querySelectorAll('.bss-b2b-customer-portal-nt-checkout-btn');
    if(ntButtons.length && BSS_B2B !== 'undefined') {
      BSS_B2B.observer.cartSubject.listenCartCheckout();
      clearInterval(interval)
    }
    ntButtons.forEach((button) => button.remove());
    BSS_BCP?.netterm.showButtonOnCartPage()
  }, 100);
  setTimeout(() => {
    clearInterval(interval)
  },2000)
})


function handle_redirect_checkout() {
    const checkoutBtn = document
        .querySelector(".button.button--large");
    if (checkoutBtn) {
        checkoutBtn.click()
    }
    return true;
}

window.BSS_B2B.addFilter('custom:redirect/checkout', handle_redirect_checkout);

document.addEventListener("DOMContentLoaded", () => {
  const targetSelector = `.main-search__input`;
  let debounceTimer;

  document.addEventListener("input", (e) => {
    if (e.target && e.target.matches(targetSelector)) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        setTimeout(()=> {
          window.dispatchEvent(new Event('scroll'));
        }, 1500)
      }, 300);
    }
  });
});

if (window.BSS_BCP?.nt?.rules.length && window.location.pathname.endsWith("/cart")) {
  document.addEventListener("DOMContentLoaded", function () {
    const interval = setInterval(function () {
      const ntButtons = document.querySelectorAll(".bss-b2b-customer-portal-nt-checkout-btn");
      if (ntButtons.length) {
        clearInterval(interval);
        ntButtons.forEach(function (ntButton) {
          ntButton.name = "";
          ntButton.classList.remove("tpo-btn-checkout");
        })
      }
    }, 100);

    setTimeout(function () {
      clearInterval(interval);
    }, 5000);
  });
}
